import api from '@/utils/api'
import {Toast} from "vant"; 
import router from '@/router'
export default {
    state: {
        userMoney:0,
        moneyApi:0,
        msg:''
    },
    getters: {
    },
    mutations: {
        setUserMoney(state, data){ 
            state.userMoney = data;
            state.moneyApi = 1;
        },
        setMsg(state, data){ 
            state.msg = data;
        },
    },
    actions: {
        getUserMoney({commit}){
            api.login.getUserMoney().then(res => {
                if (res.code == 200) {
                    commit("setUserMoney",res.money);
                 }
            });
        },
    }
}
